let WeChatPay = function(tokenClient, serviceAddr) {
    let TokenClient = tokenClient
    let ServiceBaseAddress = serviceAddr

    this.VerificationSuccessPay = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/WeChatPay/VerificationSuccessPay'
        TokenClient.Post(
            url,
            true,
            { 'Content-Type': 'application/json' },
            item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetOrgUserVersionOrderRecords = function (keyWord, startTime, endTime, upgradeType, pageIndex, pageSize, success, error) {
      var url = ServiceBaseAddress + "/api/WeChatPay/GetOrgUserVersionOrderRecords";
      if (keyWord) {
        url += `/${keyWord}`;
      } else {
        url += "/%20";
      }
      if (startTime) {
        url += `/${startTime}`;
      } else {
        url += "/%20";
      }
      if (endTime) {
        url += `/${endTime}`;
      } else {
        url += "/%20";
      }
      url += `/${upgradeType}`;
      if (pageIndex) {
        url += `/${pageIndex}`;
      }
      if (pageSize) {
        url += `/${pageSize}`;
      }
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data);
            success(jsonObj);
          }
        },
        error
      );
    };
}

export { WeChatPay }
